import constants from '../../shared/bk/modules/constants';

/**
 * Class representing an error logger.
 */
class bkErrorLog {
    /**
     * Logs a message with the specified level.
     * @param {string} message - The message to be logged.
     * @param {string} level - The log level of the message (ERROR, WARN, INFO).
     * @private
     */
    #log(message, level) {
        const data = JSON.stringify({
            context: window.location.pathname,
            level,
            message,
        });
        this.#send(data);
    }

    /**
     * Sends the logged data to the server.
     * @async
     * @param {string} data - The data to be sent.
     * @private
     */
    #send(data) {
        try {
            if (typeof csrf !== 'undefined') {
                fetch(`${constants.contextPath}app/logs/clientLogger`, {
                    method: 'POST',
                    headers: [
                        ['X-CSRF-TOKEN', csrf],
                        ['Content-Type', 'application/json'],
                    ],
                    body: data,
                });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    /**
     * Logs an error message.
     * @param {string} message - The error message to be logged.
     */
    error(message) {
        this.#log(message, 'ERROR');
    }

    /**
     * Logs a warning message.
     * @param {string} message - The warning message to be logged.
     */
    warn(message) {
        this.#log(message, 'WARN');
    }

    /**
     * Logs an informational message.
     * @param {string} message - The informational message to be logged.
     */
    info(message) {
        this.#log(message, 'INFO');
    }
}

export default bkErrorLog;
